import React from 'react';

import { useSelector } from 'react-redux';

import { getIsAsyncMergeInProgress } from 'src/redux/pull-request/selectors';

import RequestChangesButton from '../../containers/request-changes-button';

import { MergeInProgressIndicator } from './merge-in-progress-indicator';

export const OpenPullRequestActions = ({
  tabIndex,
}: {
  tabIndex: number;
}): JSX.Element => {
  const isAsyncMergeInProgress = useSelector(getIsAsyncMergeInProgress);
  if (isAsyncMergeInProgress) {
    return <MergeInProgressIndicator />;
  }
  return <RequestChangesButton removeRightBorderRadius tabIndex={tabIndex} />;
};
